import React from "react";
import { useAppSelector } from "../../../store/hooks/store.hooks";
import { ProtectedRoute } from "../../../hooks/PrivateRoute";
import { GameLayout } from "../../../layouts/game.layout";

export const GameWrapper = () => {
  const isDemo = useAppSelector((state) => state.slots.isDemo);
  if (isDemo) {
    return <GameLayout />;
  }
  return <ProtectedRoute component={GameLayout} />;
};
